// extracted by mini-css-extract-plugin
module.exports = {"dropDownWrap":"HistoryActions_dropDownWrap__0CQEt","dropDownTrigger":"HistoryActions_dropDownTrigger__zM3u6"};